<template>
  <div v-if="data">
    <div class="container">
      <div class="row">
        <div class="col-sm">
          <button type="button" class="btn btn-link btn-l" @click="$router.go(-1)">&#8592;</button>
        </div>
        <div class="col-sm" v-html="data.misc.stepXOfY"></div>
        <div class="col-sm">
          <!-- <button type="button" class="btn btn-link btn-r"
            :disabled="!ssnOrAnonymousValid" @click="$router.push('/sampling')">&#8594;</button> -->
        </div>
      </div>
      <div class="clearfix"></div>
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-md-4 card">
          <br /><br />
          <h4 class="text-primary" v-html="data.ssn.ssnHeader"></h4>
          <br />
          <label v-html="data.ssn.ssnLabel"></label>
          <input
            inputmode="numeric"
            class="form-control form-control-lg pnr"
            type="text"
            name="personalNumber"
            autocomplete="nope"
            autocapitalize="none"
            :placeholder="data.ssn.ssnFormatLabel"
            v-model="ssn"
            ref="ssn"
            @keyup.enter="enterKeyHandler()"
            :disabled="(tempssn.length != 0) || isAnonymous"
            @input="clearSsnEnforceNumbers('ssn')"
          />
          <div class="clearfix"></div>
          <label v-html="data.ssn.ssnTempLabel"></label>
          <input
            inputmode="numeric"
            class="form-control form-control-lg pnr"
            type="text"
            name="personalNumber"
            autocomplete="nope"
            autocapitalize="none"
            :placeholder="data.ssn.ssnTempFormatLabel"
            v-model="tempssn"
            @keyup.enter="enterKeyHandler()"
            :disabled="(ssn.length != 0) || isAnonymous"
            @input="clearSsnEnforceNumbers('tempssn')"
          />
          <div class="clearfix"></div>
          <div class="form-check">
            <input
              class="form-check-input"
              name="isAnonymous"
              v-model="isAnonymous"
              @change="setAsAnonymous($event)"
              :disabled="tempssn.length > 0 || ssn.length > 0"
              type="checkbox"
            />
            <label class="form-check-label" v-html="data.ssn.ssnAnonymous"></label>
            <hr />
          </div>
          <p v-html="data.ssn.ssnExplanation"></p>
          <div class="clearfix--min"></div>
          <button class="btn btn-primary btn-lg btn-block"
            :disabled="!ssnOrAnonymousValid" @click="ssnEntered()" v-html="data.misc.nextBtn"></button>
          <div class="clearfix--min"></div>
          <alert v-show="alert" v-html="data.error.errorHeader"></alert>
          <alert v-show="alert417 && alert417.visible" v-html="alert417.msg"></alert>
          <p v-html="data.ssn.ssnDisclaimer"></p>
        </div>
        <div class="col-sm"></div>
      </div>
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-sm"></div>
        <div class="col-sm"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Alert from '../../src/components/Alert'
import config from '../../config/index.js'
import axios from '../plugins/axios'
import { request } from '../plugins/datocms'
import { luhnSsn } from '../plugins/luhnssn'

export default {
  name: 'enterssn',
  components: {
    Alert
  },
  data () {
    return {
      data: null,
      alert: false,
      alert417: {
        visible: false,
        msg: null
      },
      ssn: '',
      tempssn: '',
      isAnonymous: false,
      language: sessionStorage.getItem('language'),
      isDev: process.env.NODE_ENV === 'dev',
      isQa: process.env.NODE_ENV === 'qa'
    }
  },
  methods: {
    clearSsnEnforceNumbers (ssntype) {
      if (ssntype === 'ssn') {
        this.tempssn = ''
        this.ssn = this.ssn.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1')
      } else {
        this.ssn = ''
        this.tempssn = this.tempssn.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1')
      }
    },
    clearSessionStorages () {
      sessionStorage.removeItem('sexWithoutCondomAbroad')
      sessionStorage.removeItem('currentlyLivingInMentionedRegions')
      sessionStorage.removeItem('phoneNumber')
      sessionStorage.removeItem('sexWithoutCondom')
    },
    storageToBool (sstorage) {
      return sstorage === 'true'
    },
    enterKeyHandler (e) {
      if (e.key === 'Enter' && this.isCodeLengthValid) {
        this.ssnEntered()
      }
    },
    setAsAnonymous (event) {
      if (event.target.checked) {
        this.ssn = ''
        this.tempssn = ''
      }
    },
    ssnEntered () {
      this.alert417.visible = false
      this.alert = false
      let loader = this.$loading.show()
      const code = sessionStorage.getItem('verificationCode')
      const reg = {
        socialSecurityNumber: this.isAnonymous ? null : this.ssn,
        isAnonymous: this.isAnonymous,
        reserveNumber: this.isAnonymous ? null : this.tempssn,
        phoneNumber: sessionStorage.getItem('phoneNumber'),
        languageCode: this.language,
        verificationCode: code,
        sexCondom: this.storageToBool(sessionStorage.getItem('sexWithoutCondom')),
        shareNeedle: this.storageToBool(sessionStorage.getItem('sharingSyringe')),
        sexAbroad: this.storageToBool(sessionStorage.getItem('sexWithoutCondomAbroad')),
        regions: parseInt(sessionStorage.getItem('currentlyLivingInMentionedRegions')),
        labId: (this.isDev || this.isQa) ? config.labid_karolinska_test : config.labid_karolinska_prod
      }
      if (code) {
        axios.postRegistration(config.registrationUri, reg).then((response) => {
          if (response.status === 200) {
            loader.hide()
            this.clearSessionStorages()
            this.$router.push('sampling')
          }
        }, (error) => {
          if (error.response && error.response.status === 401) {
            window.location.href = window.location.origin.concat('/error')
          } else if (error.response && error.response.status === 417) {
            loader.hide()
            this.alert417.visible = true
            this.alert417.msg = error.response.data.errorMessage
          } else {
            console.log(error)
            loader.hide()
            this.alert = true
          }
        })
      } else {
        loader.hide()
        this.alert = true
      }
    }
  },
  computed: {
    ssnOrAnonymousValid () {
      const ssnValid = luhnSsn(this.ssn)
      const tempSsnValid = luhnSsn(this.tempssn)
      return (ssnValid || tempSsnValid) || this.isAnonymous
    }
  },
  async mounted () {
    const input = document.getElementById('code-input')
    if (input) {
      input.focus()
    }
    this.data = await request({
      query: `
        {
          ssn(locale: ` + sessionStorage.getItem('language') + `) {
            ssnHeader
            ssnLabel
            ssnTempLabel
            ssnAnonymous
            ssnExplanation
            ssnDisclaimer
            ssnFormatLabel
            ssnTempFormatLabel
          }
          misc(locale: ` + sessionStorage.getItem('language') + `) {
            nextBtn
            stepXOfY
            areYouSure
          }
          error(locale: ` + sessionStorage.getItem('language') + `) {
            errorHeader
          }
        }
      `
    })
    if (this.data) {
      this.data.misc.stepXOfY = this.data.misc.stepXOfY.replace('x', '3').replace('y', '3')
    }
    setTimeout(() => { window.scrollTo(0, 0) })
    this.$nextTick(() => this.$refs.ssn.focus())
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
input[type=checkbox] {
  transform: scale(1.2);
}
.container {
  padding-bottom: 6vh;
}
.page-item {
  color: transparent !important;
}
.header-wrapper {
  display: flex;
}
.left-header {
  text-align: left;
}
.pnr {
  text-align: center;
}
button:disabled {
  opacity: 0.3;
}
input[type=text]:disabled {
  opacity: 0.3;
}
/* Portrait and Landscape */
@media only screen
  and (min-device-width: 300px)
  and (max-device-width: 812px) {
  .container {
    margin-top: 8vh;
    margin-bottom: -7.5vh;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/EnterSSN.vue